(() => {
  if(window.ttBasketBound)return;window.ttBasketBound=true;
  let busy=false;
  document.addEventListener('click',async event=>{
    const checkout=event.target.closest('[data-tt-basket-checkout]');
    if(checkout){
      const value=Number(checkout.dataset.value),count=Number(checkout.dataset.count);
      try{if(window.gtag)window.gtag('event','begin_checkout',{currency:'COP',value});if(window.fbq)window.fbq('track','InitiateCheckout',{currency:'COP',value,num_items:count});}catch{}
      return;
    }
    const button=event.target.closest('[data-tt-basket-key]');if(!button)return;
    event.preventDefault();if(busy)return;busy=true;
    const basket=button.closest('.tt-basket');basket.setAttribute('aria-busy','true');
    basket.querySelectorAll('[data-tt-basket-key]').forEach(el=>el.disabled=true);
    try{
      const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:button.dataset.ttBasketKey,quantity:Number(button.dataset.ttBasketQuantity)})});
      const result=await response.json();if(!response.ok)throw new Error(result.description||'No pudimos actualizar tu carrito.');
      location.reload();
    }catch(error){const el=basket.querySelector('[data-tt-basket-error]');el.textContent=error.message;el.hidden=false;busy=false;basket.removeAttribute('aria-busy');basket.querySelectorAll('[data-tt-basket-key]').forEach(el=>el.disabled=false);}
  });
})();
